module.exports = __webpack_public_path__ + "25692a40953691400c9924f6fd2657c9.svg";